import {Component, input, signal} from '@angular/core';
import {NavItem} from '../navigation';
import {RouterLink, RouterLinkActive} from '@angular/router';

@Component({
  selector: 'side-menu-item',
  imports: [
    RouterLinkActive,
    RouterLink,
  ],
  templateUrl: './side-menu-item.component.html',
  styleUrl: './side-menu-item.component.scss'
})
export class SideMenuItemComponent {

  item = input<NavItem>();
  isExpanded = signal(true);
  level = input<number>(0);

  levelPadding = 8; // pixels


  public toggleGroup(): void {
    this.isExpanded.update(v => !v);
  }

  public doItemAction(event: MouseEvent): void {

    const navItem = this.item();
    if (navItem == null || navItem.disabled){
      event.preventDefault();
      return;
    }
    if (!!navItem.action) {
      event.preventDefault();
      navItem.action();
      return;
    }
  }

}
